// Contact form handlers

const formWrapper = $("#form-wrapper");

function displayError(message: string): void {
    const msg = formWrapper.message(message, {
        append: false,
        classes: ['blue-gradient'],
        animate: false,
    });
    msg.bind('endfade', function () {
    }).hide().slideDown('fast');
}

function verifyEmail(em: string): boolean {
    const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return em.search(emailRegEx) !== -1;
}

export function goMsg(event: Event): void {
    if (event.preventDefault != null) event.preventDefault();

    const em = $('#email').val() as string;
    const msg = $('#msg').val() as string;
    const cc = $('#captcha_code').val() as string;

    if (em.length === 0 || msg.length === 0) {
        formWrapper.clearMessages();
        displayError('Please enter an email and message.');
        return;
    }

    if (!verifyEmail(em)) {
        formWrapper.clearMessages();
        displayError('Please enter a valid email address.');
        return;
    }

    $.post('/contact?send=1', {
        em: em,
        msg: msg,
        captcha_code: cc,
    }, function (data) {
        formWrapper.clearMessages();
        displayError(data);
    });
}
